import { Accordion, Icon, Label, Message, Segment } from "semantic-ui-react";
import React from "react";
import ResourceRow from "../ResourceRow";
import styles from "../Resources.module.css"


const DefaultMedicalResourceSlide1 = (textTitle: string) => {
  const resources = [
    {
      urlText: 'Find a Geriatrics Healthcare Professional',
      url: 'https://www.healthinaging.org/find-geriatrics-healthcare-professional',
      descriptionText: '',
      taskHeaderText: textTitle
    },
    {
      urlText: 'About a Comprehensive Geriatric Assessment',
      url: 'https://www.merckmanuals.com/professional/geriatrics/approach-to-the-geriatric-patient/comprehensive-geriatric-assessment',
      descriptionText: '',
    },
    {
      urlText: 'Choosing a Health Care Provider',
      url: 'https://medlineplus.gov/ency/article/001939.htm',
    },
    {
      urlText: 'Understanding Functional Status',
      url: 'https://www.ncbi.nlm.nih.gov/books/NBK470404/#:~:text=The%20activities%20of%20daily%20living%20(ADLs)%20is%20a%20term%20used,.%5B1%5D%5B2%5D',
    },
  ]
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        {resources.map((resource, index) => (
          <ResourceRow
            key={index}
            urlText={resource.urlText}
            url={resource.url}
            taskHeaderText={resource.taskHeaderText}
          />
        ))}
      </Segment.Group>
    </>
  );
};

const DefaultMedicalResourceSlide2 = (textTitle: string) => {
  const resources = [
    {
      urlText: "A Guide to Geriatric Syndromes",
      url: "https://www.healthinaging.org/sites/default/files/media/pdf/HIA-TipSheet%20Geriatric%20Syndromes19.pdf",
      taskHeaderText: textTitle
    },
    {
      urlText: "Aging & Health A-Z",
      url: "https://www.healthinaging.org/aging-health-a-z",
    },
    {
      urlText: "Understanding Functional Status",
      url: "https://www.ncbi.nlm.nih.gov/books/NBK470404/#:~:text=The%20activities%20of%20daily%20living%20(ADLs)%20is%20a%20term%20used,.%5B1%5D%5B2%5Dhttps://www.ncbi.nlm.nih.gov/books/NBK470404/#:~:text=The%20activities%20of%20daily%20living%20(ADLs)%20is%20a%20term%20used,.%5B1%5D%5B2%5D",
    }
  ];
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        {resources.map((resource, index) => (
          <ResourceRow
            key={index}
            urlText={resource.urlText}
            url={resource.url}
            taskHeaderText={resource.taskHeaderText}
          />
        ))}
      </Segment.Group>
    </>
  );
};

const DefaultMedicalResourceSlide3 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="How to Talk to Your Healthcare Provider"
          url="https://www.healthinaging.org/tools-and-tips/tip-sheet-how-talk-your-healthcare-provider-tips-improving-communication"
          descriptionText=""
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="Action Items on How to Take Charge of Your Health Care"
          url="https://health.gov/myhealthfinder/doctor-visits/talking-doctor/take-charge-your-health-care"
          descriptionText=""
        />
      </Segment.Group>
    </>
  );
};

const DefaultMedicalResourceSlide4 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="Safe Use of Medicines"
          url="https://order.nia.nih.gov/sites/default/files/2019-01/Safe-Use-of-Medicines_508.pdf"
          groupedHeaderText="All the following provide help with organizing and administering medications"
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="Organizing and Administering Pills"
          url="https://www.aarp.org/content/dam/aarp/ppi/2019/04/organizing-and-administering-pills.pdf"
        />
        <ResourceRow urlText="Medication Management Form"
          url="https://www.ncoa.org/article/maintaining-your-medication-record-form/"
        />
        <ResourceRow urlText="What Older Adults Can Do to Manage Medications"
          url="https://www.healthinaging.org/medications-older-adults/what-older-adults-can-do-manage-medications"
        />
      </Segment.Group>
    </>
  );
};

const DefaultMedicalResourceSlide5 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="National Database of Driving Programs and Specialists "
          url="https://myaota.aota.org/driver_search/index.aspx/index.aspx"
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="Safe Driving Tips for Older Adults"
          url="https://www.nia.nih.gov/health/older-drivers"
        />
        <ResourceRow urlText="How Does the Aging Process Affect Driving Ability?"
          url="http://health.howstuffworks.com/life-stages/aging/age-and-driving.htm"
        />
        <ResourceRow urlText="Information About Functional Driving Assessments"
          url="https://www.merckmanuals.com/professional/geriatrics/the-older-driver/functional-assessment-of-the-older-driver"
        />
        <ResourceRow urlText="Driving Evaluations for Cognitive Issues"
          url="https://www.uab.edu/medicine/pcp-tbi/pcp-resource-topics/driving/assessing-readiness-to-drive"
        />
        <ResourceRow urlText="Senior Driver Safety and Mobility Resource"
          url="https://exchange.aaa.com/safety/senior-driver-safety-mobility/evaluate-your-driving-ability/"
        />

      </Segment.Group>
    </>
  );
};

const DefaultMedicalResourceSlide6 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="Information About Geriatric Care Managers"
          url="https://www.nia.nih.gov/health/what-geriatric-care-manager"
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="Why Hire a Geriatric Care Manager?"
          url="http://newoldage.blogs.nytimes.com/2008/10/06/why-hire-a-geriatric-care-manager"
        />
      </Segment.Group>
    </>
  );
};

const DefaultMedicalResourceSlide7 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="AARP Article on Choosing a Facility"
          url="https://www.aarp.org/caregiving/basics/info-2017/assisted-living-options.html#:~:text=Your%20local%20or%20state%20Area,find%20the%20nearest%20aging%20agency"
        />
        <ResourceRow urlText="How to Research Assisted Living Facilities"
          url="https://health.usnews.com/best-assisted-living/articles/what-is-the-best-way-to-research-assisted-living-facilities"
        />
      </Segment.Group>
    </>
  );
};

const DefaultMedicalResourceSlide8 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="NIA: Exercise and Older Adults Toolkit"
          url="https://www.nia.nih.gov/exercise-toolkit"
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="Older Adult Activity: An Overview"
          url="https://www.cdc.gov/physical-activity-basics/guidelines/older-adults.html?CDC_AAref_Val=https://www.cdc.gov/physicalactivity/basics/older_adults/index.htm"
        />
        <ResourceRow urlText="What Counts as Physical Activity for Older Adults"
          url="https://www.cdc.gov/physical-activity-basics/adding-older-adults/what-counts.html?CDC_AAref_Val=https://www.cdc.gov/physicalactivity/basics/older_adults/index.htm"
        />
        <ResourceRow urlText="The Life-Changing Benefits of Exercise After 60"
          url="https://ncoa.org/article/the-life-changing-benefits-of-exercise-after-60"
        />
        <ResourceRow urlText="NIA: Exercise and Physical Activity"
          url="https://www.nia.nih.gov/health/topics/exercise-and-physical-activity"
        />
        <ResourceRow urlText="Exercise Plan for Seniors"
          url="https://www.healthline.com/health/everyday-fitness/senior-workouts"
          groupedHeaderText="Sample Exercise Plans for Seniors"
        />
        <ResourceRow urlText="Balance & Strength"
          url="https://dailycaring.com/video-15-minute-senior-exercise-program-for-balance-and-strength/"
        />
      </Segment.Group>
    </>
  );
};

const DefaultMedicalResourceSlide9 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="Dementia Care and Support Services"
          url="https://www.alzheimers.gov/"
          taskHeaderText={textTitle}
        />
        <ResourceRow urlText="Assessing Cognitive Impairment in Senior"
          url="https://www.nia.nih.gov/health/assessing-cognitive-impairment-older-patients"
        />
        <ResourceRow urlText="What to Expect from a Cognitive Assessment"
          url="https://www.alz.org/professionals/health-systems-medical-professionals/cognitive-assessment"
        />
        <ResourceRow urlText="Information on Mild Cognitive Impairment (MCI)"
          url="https://www.mayoclinic.org/diseases-conditions/mild-cognitive-impairment/symptoms-causes/syc-20354578#:~:text=You%20find%20it%20hard%20to,notice%20any%20of%20these%20changes"
        />
        <ResourceRow urlText="Fact Sheet for the Detection of Cognitive Impairment"
          url="https://www.prevention.va.gov/docs/NCP_CPS_Factsheet_Cognitive_Impairment.pdf"
        />
        <ResourceRow urlText="Tips for Caregivers of People with Alzheimer’s Disease"
          url="https://www.alzheimers.gov/life-with-dementia/tips-caregivers"
        />
      </Segment.Group>
    </>
  );
};
const DefaultMedicalResourceSlide11 = (textTitle: string) => {
  return (
    <>
      <Segment.Group raised className={styles.segmentGroup} >
        <ResourceRow urlText="Jefferson  County, AL Area Agency on Aging"
          url="https://www.uwaaa.org/"
        />
        <ResourceRow urlText="Central Alabama Resource Guide for Aging and Disabled People"
          url="https://www.uwaaa.org/services/adrc/more-adrc/"
        />
        <ResourceRow urlText="Telehealth"
          url="https://telehealth.hhs.gov/patients/why-use-telehealth?gad_source=1&gclid=Cj0KCQjwsuSzBhCLARIsAIcdLm5O1akfmvgJYq2a2sc16HrxfPnzuOecBTewOFXNZPNtLz03OofNpccaAigHEALw_wcB"
        />
        <ResourceRow urlText="YouTube Resources for Seniors"
          url="https://crestwoodmanoronline.org/news/youtube-channels-for-older-adults-our-top-10-picks/"
        />
      </Segment.Group>
    </>
  );
};

const accordionResourceDisplay = (keyVal: string, title: string, slideFunction: any) => {

  const accordions = [
    {
      key: 'keyVal',
      index: 0,
      title: {
        icon: <Icon name='dropdown' className={styles.resourcesAccordionLabelTitleIcon} />,
        content: <Label className={styles.resourcesAccordionLabelTitle} > {title} </Label>
      },
      content: {
        content: (<Message className={styles.resourcesAccordionMessageBox} content={slideFunction()} />)
      }
    }
  ];

  return (
    <>
      <div className={styles.resourceAccordionWrapper}>
        <Accordion panels={accordions} defaultActiveIndex={0} />
      </div>
    </>
  );
}

const AllResources = () => {
  return (
    <>
      {accordionResourceDisplay('MedicalDomainTask1', 'Geriatric Medical Assessment Resources', () => DefaultMedicalResourceSlide1(""))}
      {accordionResourceDisplay('MedicalDomainTask2', 'Monitoring Changes Resources', () => DefaultMedicalResourceSlide2(""))}
      {accordionResourceDisplay('MedicalDomainTask3', 'Healthcare Team Resources', () => DefaultMedicalResourceSlide3(""))}
      {accordionResourceDisplay('MedicalDomainTask4', 'Medication Management Resources', () => DefaultMedicalResourceSlide4(""))}
      {accordionResourceDisplay('MedicalDomainTask5', 'Evaluate Driving Skills Resources', () => DefaultMedicalResourceSlide5(""))}
      {accordionResourceDisplay('MedicalDomainTask6', 'Plan with Geriatric Care Manager Resources', () => DefaultMedicalResourceSlide6(""))}
      {accordionResourceDisplay('MedicalDomainTask7', 'Assess Facility Quality Resources', () => DefaultMedicalResourceSlide7(""))}
      {accordionResourceDisplay('MedicalDomainTask8', 'Exercise and Activity Plan Resources', () => DefaultMedicalResourceSlide8(""))}
      {accordionResourceDisplay('MedicalDomainTask9', 'Learn About Cognitive Impairment Resources', () => DefaultMedicalResourceSlide9(""))}
      {accordionResourceDisplay('MedicalDomainTask11', 'Learn About Cognitive Community Services', () => DefaultMedicalResourceSlide11(""))}
    </>
  );
};

const MedicalResourceFactory: React.FC<{
  questionKey: string;
}> = (props) => {
  const { questionKey } = props;

  switch (questionKey) {
    case "MedicalDomainTask1":
      return DefaultMedicalResourceSlide1('Geriatric Medical Assessment');
    case "MedicalDomainTask2":
      return DefaultMedicalResourceSlide2('Monitoring Changes');
    case "MedicalDomainTask3":
      return DefaultMedicalResourceSlide3('Healthcare Team');
    case "MedicalDomainTask4":
      return DefaultMedicalResourceSlide4('Medication Management');
    case "MedicalDomainTask5":
      return DefaultMedicalResourceSlide5('Evaluate Driving Skills');
    case "MedicalDomainTask6":
      return DefaultMedicalResourceSlide6('Plan with Geriatric Care Manager');
    case "MedicalDomainTask7":
      return DefaultMedicalResourceSlide7('Resources to Help Assess Facility Quality');
    case "MedicalDomainTask8":
      return DefaultMedicalResourceSlide8('Exercise and Activity Plan');
    case "MedicalDomainTask9":
      return DefaultMedicalResourceSlide9('Learn About Cognitive Impairment');
    case "MedicalDomainTask11":
      return DefaultMedicalResourceSlide11('Learn About Community Services');
    case "":
      return AllResources();
    default:
      return null;
  };
};

export default MedicalResourceFactory;
